export default {
    //配件申请单
    partapplyname: 'PartApply Code',
    servicename: 'Service Code',
    applytype: 'Apply Code',
    approvalstatus: 'Approval Status',

    //系统公告
    startDate:'StartDate code',
    endDate:'EndDate code',
    noticeType:'Notice Type',
    noticeTitle:'Notice Title',
    noticeState:'Notice State'
};


// WEBPACK FOOTER //
// ./src/module/locale/lang/en.js